import { gql } from 'graphql-request'

export const ManyAlumniActivitiesQuery = gql`
  query ManyAlumniActivities(
    $now: DateTime!
    $limit: Int! = 100,
    $page:Int! = 1,
    $locale: LocaleInputType!
    $sort: String = "-visibleUntil"
  ) {
    AlumniActivities(
      limit: $limit,
      sort: $sort,
      page: $page,
      locale: $locale,
      where: {
        AND: [
          { _status: { equals: published } }
          { visibleUntil: { greater_than_equal: $now } }
        ]
      }
    ) {
      docs {
        id
        title
        dateTimeStart
        dateTimeEnd
        visibleUntil
        types {
          id
          title
        }
        people {
          id
          title
          slug
        }
        externalLink
      }
      totalDocs
      limit
      totalPages
      page
      pagingCounter
      hasPrevPage
      hasNextPage
      prevPage
      nextPage
    }
  }
`
